export default {
  data() {
    return {
      searchSchema: [
        {
          label: '文档名',
          type: 'input',
          itemName: 'name',
        },
        {
          label: '创建时间',
          type: 'rangePicker',
          itemName: 'date',
          format: 'YYYY-MM-DD',
        },
        {
          label: '文件类型',
          type: 'select',
          itemName: 'type',
          selectList: [
            {
              text: '全部',
              value: '',
            },
          ],
          placeholder: '全部',
          allowClear: true,
        },
        // {
        //   label: '状态',
        //   type: 'select',
        //   itemName: 'status',
        //   selectList: [
        //     {
        //       text: '生效',
        //       value: 1
        //     },
        //     {
        //       text: '失效',
        //       value: 2
        //     }
        //   ],
        //   placeholder: '全部',
        //   allowClear: true
        // }
      ],
      searchForm: {
        name: '',
        date: [],
        type: '',
        status: 1,
        endTime: '',
        startTime: '',
      },
      pageData: {
        pageSize: 10,
        current: 1,
        total: 0,
        showTotal: total => `共${total}条`,
      },
      tableData: [],
      tableColumns: [
        {
          fixed: 'left',
          title: '序号',
          width: 80,
          customRender: (text, record, index) => {
            return (
              (this.pageData.current - 1) * this.pageData.pageSize + index + 1
            )
          },
        },
        {
          title: '文件夹名称',
          width: 120,
          dataIndex: 'name',
        },
        {
          title: '文档类型',
          width: 100,
          dataIndex: 'type',
        },
        {
          title: '上传时间',
          width: 200,
          dataIndex: 'createTime',
        },
        {
          title: '上传人',
          width: 150,
          dataIndex: 'operator',
        },
        {
          title: '状态',
          width: 110,
          scopedSlots: { customRender: 'status' },
        },
        {
          title: '备注',
          width: 130,
          dataIndex: 'remark',
        },
        {
          title: '文件链接',
          width: 100,
          scopedSlots: { customRender: 'files' },
        },
        {
          title: '操作',
          width: 140,
          fixed: 'right',
          scopedSlots: { customRender: 'action' },
        },
      ],
      selectList: [],
    }
  },
  methods: {
    // 查询
    handleSearch(data) {
      this.searchForm = { ...this.searchForm, ...data }
      this.pageData.current = 1
      this._getTableData()
    },
    // 点击分页按钮
    handleClickPage({ current, pageSize }) {
      this.pageData = { ...this.pageData, current, pageSize }
      this._getTableData()
    },
  },
}
